"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getCroppedImg = getCroppedImg;
exports.getRotatedImage = getRotatedImage;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var createImage = function createImage(url) {
  return new Promise(function (resolve, reject) {
    var image = new Image();
    image.addEventListener("load", function () {
      return resolve(image);
    });
    image.addEventListener("error", function (error) {
      return reject(error);
    });
    image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox

    image.src = url;
  });
};

var getRadianAngle = function getRadianAngle(degreeValue) {
  return degreeValue * Math.PI / 180;
};
/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} image - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 * @param {number} rotation - optional rotation parameter
 */


function getCroppedImg(_x, _x2, _x3, _x4) {
  return _getCroppedImg.apply(this, arguments);
}

function _getCroppedImg() {
  _getCroppedImg = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(imageSrc, pixelCrop, rotation, imageName) {
    var image, canvas, ctx, safeArea, data;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (rotation === void 0) {
              rotation = 0;
            }

            _context.next = 3;
            return createImage(imageSrc);

          case 3:
            image = _context.sent;
            canvas = document.createElement("canvas");
            ctx = canvas.getContext("2d");
            safeArea = 4000; // set each dimensions to double largest dimension to allow for a safe area for the
            // image to rotate in without being clipped by canvas context

            canvas.width = safeArea;
            canvas.height = safeArea; // translate canvas context to a central location on image to allow rotating around the center.

            ctx.translate(safeArea / 2, safeArea / 2);
            ctx.rotate(getRadianAngle(rotation));
            ctx.translate(-safeArea / 2, -safeArea / 2); // draw rotated image and store data.

            ctx.drawImage(image, safeArea / 2 - image.width * 0.5, safeArea / 2 - image.height * 0.5);
            data = ctx.getImageData(0, 0, safeArea, safeArea); // set canvas width to final desired crop size - this will clear existing context

            canvas.width = pixelCrop.width;
            canvas.height = pixelCrop.height; // paste generated rotate image with correct offsets for x,y crop values.

            ctx.putImageData(data, Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x), Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y)); // As Base64 string
            // return canvas.toDataURL('image/jpeg');
            // As a blob

            return _context.abrupt("return", new Promise(function (resolve) {
              canvas.toBlob(function (file) {
                var createdFile = new File([file], imageName, {
                  type: "image/png"
                });
                resolve(createdFile);
              }, "image/png");
            }));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getCroppedImg.apply(this, arguments);
}

function getRotatedImage(_x5, _x6) {
  return _getRotatedImage.apply(this, arguments);
}

function _getRotatedImage() {
  _getRotatedImage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(imageSrc, rotation) {
    var image, canvas, ctx, orientationChanged;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (rotation === void 0) {
              rotation = 0;
            }

            _context2.next = 3;
            return createImage(imageSrc);

          case 3:
            image = _context2.sent;
            canvas = document.createElement("canvas");
            ctx = canvas.getContext("2d");
            orientationChanged = rotation === 90 || rotation === -90 || rotation === 270 || rotation === -270;

            if (orientationChanged) {
              canvas.width = image.height;
              canvas.height = image.width;
            } else {
              canvas.width = image.width;
              canvas.height = image.height;
            }

            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(rotation * Math.PI / 180);
            ctx.drawImage(image, -image.width / 2, -image.height / 2);
            return _context2.abrupt("return", new Promise(function (resolve) {
              canvas.toBlob(function (file) {
                resolve(URL.createObjectURL(file));
              }, "image/png");
            }));

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getRotatedImage.apply(this, arguments);
}